import { defineMessages, type MessageDescriptor } from 'react-intl';

export const messages: Record<string, MessageDescriptor> = defineMessages({
	depletedWithContextAndResetDate: {
		id: 'rovo-credits.internal.credits-banner-content.depletedWithContextAndResetDate',
		defaultMessage: 'Out of Rovo credits. {additionalContext} Resets {resetDate}.',
		description:
			'Depleted credits message with a host-provided localized sentence, including its punctuation, before the localized reset date.',
	},
	depletedWithContext: {
		id: 'rovo-credits.internal.credits-banner-content.depletedWithContext',
		defaultMessage: 'Out of Rovo credits. {additionalContext}',
		description:
			'Depleted credits message with a host-provided localized sentence when no valid reset date is available.',
	},
	warningWithContextAndResetDate: {
		id: 'rovo-credits.internal.credits-banner-content.warningWithContextAndResetDate',
		defaultMessage: 'Rovo credits running low. {additionalContext} Resets {resetDate}.',
		description:
			'Warning with a host-provided localized sentence, including its punctuation, followed by the localized reset date.',
	},
	warningWithContext: {
		id: 'rovo-credits.internal.credits-banner-content.warningWithContext',
		defaultMessage: 'Rovo credits running low. {additionalContext}',
		description:
			'Warning with a host-provided localized sentence when no valid reset date is available.',
	},
	warningWithResetDate: {
		id: 'rovo-credits.internal.credits-banner-content.warningWithResetDate',
		defaultMessage: 'Rovo credits running low. Resets {resetDate}.',
		description: 'Warning banner copy with the localized date when credits reset.',
	},
	warningWithoutResetDate: {
		id: 'rovo-credits.internal.credits-banner-content.warningWithoutResetDate',
		defaultMessage: 'Rovo credits running low.',
		description: 'Warning banner copy when no valid credit reset date is available.',
	},
	depletedWithResetDate: {
		id: 'rovo-credits.internal.credits-banner-content.depletedWithResetDate',
		defaultMessage: 'Out of Rovo credits. Resets {resetDate}.',
		description:
			'Message shown when Rovo credits are exhausted. resetDate is the localized date when credits reset, for example Nov 15.',
	},
	agentDepletedWithContextAndResetDate: {
		id: 'rovo-credits.internal.credits-banner-content.agentDepletedWithContextAndResetDate',
		defaultMessage: '{agentName} is out of Rovo credits. {additionalContext} Resets {resetDate}.',
		description:
			'Agent depleted credits message with a host-provided localized sentence, including its punctuation, before the localized reset date. agentName is the name of the agent that reached its usage limit.',
	},
	agentDepletedWithContext: {
		id: 'rovo-credits.internal.credits-banner-content.agentDepletedWithContext',
		defaultMessage: '{agentName} is out of Rovo credits. {additionalContext}',
		description:
			'Agent depleted credits message with a host-provided localized sentence when no valid reset date is available. agentName is the name of the agent that reached its usage limit.',
	},
	agentDepletedWithResetDate: {
		id: 'rovo-credits.internal.credits-banner-content.agentDepletedWithResetDate',
		defaultMessage: '{agentName} is out of Rovo credits. Resets {resetDate}.',
		description:
			'Message shown when an agent has reached its Rovo credits usage limit. agentName is the name of the agent that reached its usage limit. resetDate is the localized date when its credits reset, for example Nov 15.',
	},
	agentDepletedWithoutResetDate: {
		id: 'rovo-credits.internal.credits-banner-content.agentDepletedWithoutResetDate',
		defaultMessage: '{agentName} is out of Rovo credits.',
		description:
			'Message shown when an agent has reached its Rovo credits usage limit and no reset date is available. agentName is the name of the agent that reached its usage limit.',
	},
	depletedWithoutResetDate: {
		id: 'rovo-credits.internal.credits-banner-content.depletedWithoutResetDate',
		defaultMessage: 'Out of Rovo credits.',
		description: 'Message shown when Rovo credits are exhausted and no reset date is available.',
	},
	requestMore: {
		id: 'rovo-credits.internal.credits-banner-content.requestMore',
		defaultMessage: 'Request more',
		description: 'Link text for requesting more Rovo credits.',
	},
	orViewUsage: {
		id: 'rovo-credits.internal.credits-banner-content.orViewUsage',
		defaultMessage: 'or <link>view usage</link>',
		description: 'Alternative action after Request more. Only View usage is linked.',
	},
	viewUsage: {
		id: 'rovo-credits.internal.credits-banner-content.viewUsage',
		defaultMessage: '<link>View usage</link>',
		description: 'Link to credits usage when requesting more credits is unavailable.',
	},
	dismissBanner: {
		id: 'rovo-credits.credits-banner.dismiss-banner.non-final',
		defaultMessage: 'Dismiss banner',
		description: 'Label for the button that dismisses the Rovo credits warning banner.',
	},
});
